
  import { mapState } from 'vuex';

  import gtag from "@/mixins/gtag";

  import { GET_BOOKING_NETWORK_PROMOTIONS } from '@/store/booking-networks/constants';

  export default {
    name: "Index",
    middleware: [
      'load-page-blocks'
    ],
    mixins: [
      gtag,
    ],
    beforeMount() {
      this.$store.dispatch(GET_BOOKING_NETWORK_PROMOTIONS);
    },
    methods: {
      isSinglePromotion(property) {
        return property.promotions.length == 1;
      },
    },
    computed: {
      getHeaderStyle() {
        let image =
          "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80";

        if (!!this.network?.images?.length) {
          image = this.network.images[0].sizes_full_path.high;
        }

        return `
          background-image: url(${image});
          background-position: center center;
          background-repeat: no-repeat;
          background-attachment: scroll
          background-size: cover;
          background-color: #999;`;
      },
      ...mapState({
        propertyPromotions: state => state['booking-networks'].getBookingNetworkPromotionsRequest.data,
      }),
    },
  }
